import { memo, useCallback } from "react";
import type { GridRowIdGetter } from "@mui/x-data-grid";
import { FilterVariant } from "consts/filters";
import { TableGridMode } from "consts/table";
import { MenuItem } from "consts/waMessaging";
import { usePhoneVerificationsActions } from "features/waMessaging/actions";
import {
    selectIsWaMessagingResourceLoading,
    selectIsWaMessagingResourceUninitialized,
    selectWaMessagingResourceSlice
} from "features/waMessaging/selectors";
import type { PhoneVerification } from "features/waMessaging/types";
import Resource from "ui/layouts/Resource";
import Table from "ui/widgets/Table";

const PhoneVerifications = () => {
    const { getPhoneVerifications, downloadCsv } = usePhoneVerificationsActions();

    const getRowId: GridRowIdGetter<PhoneVerification> = useCallback(
        ({ phone }: PhoneVerification) => phone,
        []
    );

    return (
        <Resource
            breadcrumbsProps={{
                heading: 'Phone Verifications',
                links: [{ name: '' }],
                sx: { mb: 0 }
            }}
        >
            <Table
                mode={TableGridMode.PhoneVerifications}
                selectIsTableUninitialized={selectIsWaMessagingResourceUninitialized(MenuItem.PhoneVerifications)}
                selectIsTableLoading={selectIsWaMessagingResourceLoading(MenuItem.PhoneVerifications)}
                selectTableDataSlice={selectWaMessagingResourceSlice(MenuItem.PhoneVerifications)}
                fetchTableData={getPhoneVerifications}
                downloadCsv={downloadCsv}
                filterTypes={new Map<FilterVariant, string[]>()}
                getRowId={getRowId}
                LayoutProps={{ sx: { m: '24px 0px' } }}
                FiltersProps={{ sx: { m: 0 } }}
            />
        </Resource>
    );
};

export default memo(PhoneVerifications);
